import { useState } from "react";
import { buildMagicLink } from "../lib/links";
import { QrCode } from "./QrCode";

/* ───────────────────── SHARE LINKS PANEL ───────────────────── */
export function ShareLinksPanel({ team }) {
  const [copiedLabel, setCopiedLabel] = useState("");

  if (!team.passcode) {
    return <p className="text-xs text-gray-400 italic">Passcode data not available. Try clicking "Passcodes" first to confirm team has passcodes set.</p>;
  }

  const parentLink = buildMagicLink(team.id, team.passcode);
  const coachLink = team.coachPasscode ? buildMagicLink(team.id, team.coachPasscode) : null;

  const handleCopy = (text, label) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedLabel(label);
      setTimeout(() => setCopiedLabel(""), 2000);
    });
  };

  return (
    <div className="space-y-4">
      {/* Parent link */}
      <div>
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs font-semibold text-gray-600">Parent Link</span>
          <span className="text-xs text-gray-400">(goes to player name entry)</span>
        </div>
        <div className="flex gap-2 items-start">
          <div className="flex-1 min-w-0">
            <div className="flex gap-1">
              <input type="text" readOnly value={parentLink}
                className="flex-1 px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-mono bg-gray-50 text-gray-600 truncate" />
              <button onClick={() => handleCopy(parentLink, "parent")}
                className={"px-3 py-1.5 text-xs rounded-lg border transition-colors flex-shrink-0 " +
                  (copiedLabel === "parent" ? "bg-green-100 border-green-300 text-green-700" : "border-blue-200 text-blue-700 hover:bg-blue-50")}>
                {copiedLabel === "parent" ? "Copied!" : "Copy"}
              </button>
            </div>
          </div>
          <QrCode value={parentLink} size={120} alt="Parent QR" className="w-[60px] h-[60px] rounded border border-gray-200" />
        </div>
      </div>

      {/* Coach link */}
      {coachLink && (
        <div>
          <div className="flex items-center gap-2 mb-2">
            <span className="text-xs font-semibold text-gray-600">Coach Link</span>
            <span className="text-xs text-gray-400">(goes to coach dashboard)</span>
          </div>
          <div className="flex gap-2 items-start">
            <div className="flex-1 min-w-0">
              <div className="flex gap-1">
                <input type="text" readOnly value={coachLink}
                  className="flex-1 px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-mono bg-gray-50 text-gray-600 truncate" />
                <button onClick={() => handleCopy(coachLink, "coach")}
                  className={"px-3 py-1.5 text-xs rounded-lg border transition-colors flex-shrink-0 " +
                    (copiedLabel === "coach" ? "bg-green-100 border-green-300 text-green-700" : "border-blue-200 text-blue-700 hover:bg-blue-50")}>
                  {copiedLabel === "coach" ? "Copied!" : "Copy"}
                </button>
              </div>
            </div>
            <QrCode value={coachLink} size={120} alt="Coach QR" className="w-[60px] h-[60px] rounded border border-gray-200" />
          </div>
        </div>
      )}

      {/* Full-size QR codes */}
      <div className="flex gap-4 pt-2">
        <div className="text-center">
          <QrCode value={parentLink} size={400} alt="Parent QR large" className="w-32 h-32 rounded-lg border border-gray-200 shadow-sm" />
          <p className="text-xs text-gray-500 mt-1">Parent QR</p>
        </div>
        {coachLink && (
          <div className="text-center">
            <QrCode value={coachLink} size={400} alt="Coach QR large" className="w-32 h-32 rounded-lg border border-gray-200 shadow-sm" />
            <p className="text-xs text-gray-500 mt-1">Coach QR</p>
          </div>
        )}
      </div>
      <p className="text-xs text-gray-400">Print or screenshot the QR codes to share at practice. Parents scan to go straight to their team.</p>
    </div>
  );
}
